module.exports = __webpack_public_path__ + "img/ico050.321177d5.svg";